import { render, staticRenderFns } from "./searchSuggestCase.vue?vue&type=template&id=e4165db6&scoped=true&"
import script from "./searchSuggestCase.vue?vue&type=script&lang=js&"
export * from "./searchSuggestCase.vue?vue&type=script&lang=js&"
import style0 from "./searchSuggestCase.vue?vue&type=style&index=0&id=e4165db6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4165db6",
  null
  
)

export default component.exports